(() => {
  const body = document.querySelector('.aq-policy-shipping .shopify-policy__body .rte');
  if (!body) return;
  const normalize = text => text.replace(/\s+/g, ' ').trim();
  const original = '* All items will be delivered by Australia Post eParcel, Regular Letter mail or Freight Courier Depends on the different Items. * All orders will usually be processed and dispatched to ship within 2 Business Days of receiving CLEARED PAYMENT. * Please double check your delivery address before you check out.';
  if (normalize(body.textContent) !== original) return;
  const topics = [
    ['Delivery methods', 'Depending on the item, orders are delivered by Australia Post eParcel, regular letter mail or a freight courier.'],
    ['Processing and dispatch', 'Orders are usually processed and dispatched within 2 business days of receiving cleared payment.'],
    ['Your delivery address', 'Please double-check your delivery address before completing checkout.']
  ];
  const content = document.createDocumentFragment();
  topics.forEach(([heading, text]) => {
    const section = document.createElement('section');
    section.className = 'aq-shipping-topic';
    const title = document.createElement('h2');
    title.textContent = heading;
    const paragraph = document.createElement('p');
    paragraph.textContent = text;
    section.append(title, paragraph);
    content.append(section);
  });
  body.replaceChildren(content);
})();
